import React from 'react';
import { Badge } from './TabLabelStyles';
import { ReactComponent as NotVerifiedIcon } from 'images/notVerified.svg';
import { ReactComponent as VerifiedIcon } from 'images/verified.svg';

interface IProps {
  label: React.ReactNode;
  isVerified: boolean;
}

const TabLabel: React.FC<IProps> = (props) => {
  const { label, isVerified } = props;

  return (
    <div>
      {isVerified ? (
        <Badge>
          <VerifiedIcon /> Verified
        </Badge>
      ) : (
        <Badge>
          <NotVerifiedIcon /> Not verified
        </Badge>
      )}
      <div>{label}</div>
    </div>
  );
};

export default TabLabel;
